module.exports = __webpack_public_path__ + "img/logoW.1414b6fa.svg";